import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ArrowDown } from "lucide-react";
import { api } from "@/lib/api";
import { Panel } from "@/components/admin/AdminLayout";

const COLS = [["name", "Store"], ["d7", "7 days"], ["d30", "30 days"], ["d90", "90 days"]];

export const StoreClicks = () => {
  const [sort, setSort] = useState("d30");
  const { data } = useQuery({ queryKey: ["store-clicks"], queryFn: () => api.get("/admin/store-clicks").then((r) => r.data) });
  const rows = [...(data || [])].sort((a, b) => (sort === "name" ? a.name.localeCompare(b.name) : b[sort] - a[sort]));
  const total = (k) => rows.reduce((s, r) => s + r[k], 0);
  return (
    <Panel title="Visit store clicks" testid="store-clicks-panel">
      <p className="text-xs text-slate-500 mb-3">Clicks on the “Visit store” button on store pages. Tap a column to sort.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="store-clicks-table">
          <thead className="text-left text-xs uppercase text-slate-500">
            <tr>{COLS.map(([k, l]) => (
              <th key={k} className={`p-2 ${k !== "name" ? "text-right" : ""}`}>
                <button onClick={() => setSort(k)} className={`inline-flex items-center gap-1 uppercase ${sort === k ? "text-emerald-700 font-bold" : ""}`} data-testid={`store-clicks-sort-${k}`}>
                  {l}{sort === k && <ArrowDown size={12} />}
                </button>
              </th>
            ))}</tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.merchant_id} className="border-t border-slate-100" data-testid={`store-clicks-row-${r.slug || r.merchant_id}`}>
                <td className="p-2">{r.slug ? <a href={`/store/${r.slug}`} target="_blank" rel="noreferrer" className="hover:underline">{r.name}</a> : r.name}</td>
                <td className="p-2 text-right tabular-nums">{r.d7}</td>
                <td className="p-2 text-right tabular-nums">{r.d30}</td>
                <td className="p-2 text-right tabular-nums">{r.d90}</td>
              </tr>
            ))}
            {rows.length > 0 && (
              <tr className="border-t-2 border-slate-200 font-bold" data-testid="store-clicks-total">
                <td className="p-2">Total</td>{["d7", "d30", "d90"].map((k) => <td key={k} className="p-2 text-right tabular-nums">{total(k)}</td>)}
              </tr>
            )}
          </tbody>
        </table>
        {data && !data.length && <p className="text-slate-500 text-sm py-4">No Visit store clicks in the last 90 days yet.</p>}
      </div>
    </Panel>
  );
};
